import { render } from "./CommunityMain.vue?vue&type=template&id=7c7fe42c&scoped=true"
import script from "./CommunityMain.vue?vue&type=script&lang=js"
export * from "./CommunityMain.vue?vue&type=script&lang=js"

import "./CommunityMain.vue?vue&type=style&index=0&id=7c7fe42c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7fe42c"]])

export default __exports__